module.exports = __webpack_public_path__ + "img/141.98df6de7.jpg";